import { ReferenceInput, AutocompleteInput, required, useSimpleFormIteratorItem } from "react-admin";
import { useWatch } from "react-hook-form";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { specialistRequests } from "api/specialistApi";

const SpecializationRow = ({ excludeIds: alreadyAddedIds = [] }) => {
  const { index } = useSimpleFormIteratorItem();
  const specializations = useWatch({ name: "specializations" });

  const excludeIds = [
    ...alreadyAddedIds,
    ...(specializations
      ?.filter((_, i) => i !== index)
      .map(s => s?.specializationId)
      .filter(Boolean) ?? []),
  ];

  return (
    <>
      <ReferenceInput
        source="specializationId"
        reference={specialistRequests.getSpecializationsSelect()}
        filter={excludeIds.length > 0 ? { ExcludeIds: excludeIds } : {}}
      >
        <AutocompleteInput
          label="Специалност"
          optionText="nameBg"
          fullWidth
          validate={[required()]}
          filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
        />
      </ReferenceInput>
      <CustomDateInput
        source="accreditationExpiryDate"
        label="Валидност на акредитация"
        validate={required()}
        noTime
      />
    </>
  );
};

export default SpecializationRow;
